import { hasClusterGroups } from 'src/components/Search/Common/Filters/utils/hasClusterGroups';
import { ClusterKey } from 'src/types/search/common/clusters';

import { useSearchClusterState } from 'src/components/Search/Common/Filters/hooks/useSearchClusterState';

export const useHasClusterGroups = (filter: ClusterKey) => {
    const cluster = useSearchClusterState(filter);
    return hasClusterGroups(cluster);
};
